import React, {useContext} from "react";
import cancel from "../../../../../../assets/cancel.svg";
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";
import {MessageBottomContainerContext} from "../../../Message.tsx";

interface CancelProps {}

const Cancel: React.FC<CancelProps> = ({ }) => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const { setEditedContent } = useContext(MessageBottomContainerContext);


    const handleCancelClick = () => {
        setDynamicStateObj({editingId: null});
        setEditedContent([]);
    };

    return (
        <button
            className="h-5 w-5 cursor-pointer"
            onClick={handleCancelClick}
        >
            <img
                src={`${cancel}`}
                alt="Cancel"
            />
        </button>
    )
}

export default Cancel;
